<style scoped>
.button-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  padding: 0px 10px 8px 10px;
  box-shadow: 0px 0px 10px 11px white;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: space-evenly;
  background-color: #ffffffe0;
}

.root {
  height: 100%;
  position: relative;
}

.button-container a {
  flex: 1;
  height: 100%;
  line-height: 56px;
  margin-left: 2.5px;
  margin-right: 2.5px;
}

.input-field,
.input-field label {
  padding-left: 35px;
}

ul.order-items li {
  padding-top: 24px;
}

ul.order-items li:not(:last-child) {
  border-bottom: 1px solid #efefef;
}
</style>

<template lang="pug">
.root
  .container
    v-list
      v-list-item
        v-list-item-content
          v-list-item-title 
            strong Shipping Information
          v-list-item-subtitle Reference #: {{ order.referenceNumber }}
      v-list-item
        v-list-item-content
          v-list-item-title 
            strong Payment Method
          v-list-item-subtitle {{ paymentMethod }}
          v-list-item-subtitle Ordered on {{ $utils.formatter.formatLongDateTime(order.createdAt) }}
      v-list-item
        v-list-item-content
          v-list-item-title 
            strong Delivery Address
          v-list-item-subtitle {{ deliveryAddress }}
      v-list-item
        v-list-item-content
          v-list-item-title 
            strong Items
          ul.order-items
            li(
              v-for='item in sortedOrderItems',
              v-if='checkStatus(item.status)'
            )
              .row
                .col.s12.m8
                  strong.title.text-uppercase.black-text {{ item.quantity }} X {{ item.productVariant.product.name }}
                    span.subtitle.micro(:class='getStatusClass(item.status)') &nbsp;&nbsp;{{ item.status }}
                    span.subtitle.micro(
                      :class='getStatusClass(item.status)',
                      v-if='item.status === STATUS_INTRANSIT && item.deliveredBy === "inomph"'
                    ) (Inom.ph)
                    p.subtitle.micro ({{ item.productVariant.variantCode }})
                    p.subtitle.micro Deliver {{ getDeliverySchedule(item.deliverySchedule) }}
                .col.s12.m4
                  p.right-align {{ $utils.formatter.formatAmount(item.price * item.quantity) }}
              .row(v-if='item.issue')
                .col.s12
                  p.red-text
                    i.material-icons.left warning
                    | {{ item.issue }}
</template>
<script>
// import AppConfirmModalContent from './app-confirm-modal-content'

export default {
  name: 'apporderdetails',
  props: ['order', 'filter'],
  data() {
    return {
      STATUS_NEW: 'new',
      STATUS_DECLINED: 'declined',
      STATUS_CANCELLED: 'cancelled',
      STATUS_PROCESSING: 'processing',
      STATUS_INTRANSIT: 'in-transit',
      STATUS_DELIVERED: 'delivered',
      selectedItems: [],
    }
  },
  watch: {
    '$route.params.referenceNumber'() {
      this.resetSelection()
    },
  },
  computed: {
    paymentMethod() {
      return this.order.paymentOption === 'cash'
        ? 'Cash'
        : this.order.paymentOption === 'bank'
        ? 'Bank Deposit'
        : null
    },
    deliveryAddress() {
      return this.order.orderItems[0].address
    },
    contactNumber() {
      return this.order.orderItems[0].contactNumber
    },
    sortedOrderItems() {
      let copy = this.order.orderItems.slice()
      return copy.sort(this.sortCompareItem)
    },
    filterBy() {
      return this.filter
    },
  },
  methods: {
    sortCompareItem(itemA, itemB) {
      if (itemA.status === itemB.status) {
        return 0
      }

      if (
        [this.STATUS_DECLINED, this.STATUS_CANCELLED].includes(itemA.status) ||
        itemB.status === this.STATUS_NEW
      ) {
        return 1
      }

      if (
        itemA.status === this.STATUS_NEW ||
        (itemA.status === this.STATUS_PROCESSING &&
          (itemB.status === this.STATUS_INTRANSIT ||
            itemB.status === this.STATUS_DELIVERED)) ||
        (itemA.status === this.STATUS_INTRANSIT &&
          itemB.status === this.STATUS_DELIVERED) ||
        [this.STATUS_DECLINED, this.STATUS_CANCELLED].includes(itemB.status)
      ) {
        return -1
      }

      return 1
    },
    canSelect(item) {
      return ![
        this.STATUS_DECLINED,
        this.STATUS_DELIVERED,
        this.STATUS_CANCELLED,
      ].includes(item.status)
    },
    resetSelection() {
      this.selectedItems = []
      document.querySelectorAll('input[type=checkbox]').forEach((checkbox) => {
        checkbox.checked = false
      })
    },
    getDeliverySchedule(value) {
      if (value === 'same_day') {
        return 'By Today'
      } else if (value.startsWith('range')) {
        return (
          'By ' + value.split(':')[1].replace(';', ' to ') + ' business days'
        )
      } else if (value.startsWith('scheduled')) {
        return 'On ' + value.split(':')[1]
      }
    },
    getStatusClass(status) {
      return {
        'indigo-text': status === this.STATUS_NEW,
        'green-text': status === this.STATUS_DELIVERED,
        'red-text':
          status === this.STATUS_DECLINED || status === this.STATUS_CANCELLED,
        'blue-text': status === this.STATUS_INTRANSIT,
        'orange-text': status === this.STATUS_PROCESSING,
      }
    },
    checkStatus(stat) {
      if (this.filterBy === 'declined' && stat === 'cancelled') {
        return true
      } else if (this.filterBy === 'default') {
        return true
      } else {
        if (this.filterBy === stat) {
          return true
        } else {
          return false
        }
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-order-details.vue